import React from "react";
import { ArrowRight, Award, Download } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
export default function ClaimYourSuccess() {
  return <section data-section-id="231617" id="join-the-simple-living-movement" className="dark bg-background text-foreground relative flex min-h-[80vh] items-center justify-center overflow-hidden px-4 py-24 md:px-6 lg:px-8">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/5 via-background to-background pointer-events-none opacity-40" />

      <div className="relative z-10 w-full max-w-md">
        <Card className="border-border/20 bg-card/40 shadow-4xl shadow-black/60 backdrop-blur-2xl rounded-3xl">
          <CardHeader className="pb-4 text-center">
            <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary ring-1 ring-primary/20">
              <Award className="h-7 w-7" />
            </div>
            <CardTitle className="font-default text-2xl font-bold tracking-tight md:text-3xl text-foreground">
              Join the Simple Living Movement
            </CardTitle>
            <CardDescription className="mt-3 text-base text-muted-foreground font-sans">
              Master the art of HomeKit automation with moza casa's exclusive digital zen guides.
            </CardDescription>
          </CardHeader>
          
          <CardContent className="pb-8 pt-2 text-center">
            <div className="flex flex-col items-center justify-center gap-1">
              <span className="text-lg font-medium text-muted-foreground/50 line-through decoration-primary/30">
                Digital Noise
              </span>
              <div className="flex items-baseline justify-center gap-1.5">
                <span className="font-default text-5xl font-extrabold tracking-tighter text-primary">
                  Pure
                </span>
                <span className="text-sm font-medium text-muted-foreground font-sans">
                  /intent
                </span>
              </div>
              <span className="mt-3 inline-flex items-center rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold text-primary ring-1 ring-primary/20 tracking-widest uppercase">
                Exclusive Access
              </span>
            </div>
          </CardContent>

          <CardFooter className="flex flex-col gap-3">
            <Button className="h-12 w-full text-base font-semibold shadow-lg shadow-primary/10 bg-primary text-primary-foreground hover:opacity-90 transition-opacity rounded-full" size="lg" asChild>
              <Link to="#">
                Join Now <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            <Button variant="ghost" className="h-12 w-full text-muted-foreground hover:bg-muted/20 hover:text-foreground rounded-full font-sans" asChild>
              <Link to="#">
                <Download className="mr-2 h-4 w-4" /> The Moza Method PDF
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}